interface Props {
  title: string
  description: string
  icon?: string
}

export function ComingSoon({ title, description, icon = '🚧' }: Props) {
  return (
    <div className="p-8 max-w-7xl mx-auto">
      <h1 className="font-display text-3xl font-bold text-text mb-2">{title}</h1>
      <p className="text-text-muted mb-8">{description}</p>
      <div className="bg-surface rounded-xl border border-slate-200 p-8 text-center">
        <div className="text-4xl mb-4">{icon}</div>
        <p className="text-text-muted">Coming soon</p>
      </div>
    </div>
  )
}
